import React, { useState } from 'react';
import DashboardSection from '../components/DashboardSection';
import useDeepLinkedSection from '../navigation/useDeepLinkedSection';

// DJB-175: the Configuration sections sit on the Dashboard's borderless
// collapsible shell (DJB-127), like the rest of the admin. Sections start
// expanded (they were always visible before); the left nav's ?section=<anchor>
// deep link re-opens a section the user collapsed (DJB-112). The header is a
// single toggle button, so the `actions` slot (e.g. the "New …" button) moved
// to the top of the section body.
const ConfigSection = ({ anchorId, title, actions, children }) => {
  const [isOpen, setIsOpen] = useState(true);

  useDeepLinkedSection({ [anchorId]: anchorId }, () => setIsOpen(true));

  return (
    <DashboardSection
      id={anchorId}
      title={title}
      isOpen={isOpen}
      onToggle={() => setIsOpen((prev) => !prev)}
      bodyId={`${anchorId}-body`}
    >
      {actions && <div className="config-section-actions">{actions}</div>}
      {children}
    </DashboardSection>
  );
};

export default ConfigSection;
